<form fxFlexFill [formGroup]="noteForm" class="note-dialog">
    <lgd-textarea controlName="note" label="Subject">
    </lgd-textarea>
</form>